(function () {
    var image = $('.jarallax-img');
    if (!image) return;

    var options = {
        disableParallax: /iPad|iPhone|iPod|Android/,
        disableVideo: /iPad|iPhone|iPod|Android/,
        speed: 0.1,
    };

    image.imagesLoaded(function () {
        image.parent().jarallax(options).addClass('initialized');
    });
})();

(function () {
    'use strict';
    $('.featured-posts').owlCarousel({
        dots: false,
        margin: 30,
        nav: true,
        navText: [
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="18" height="18" fill="currentColor"><path d="M20.547 22.107L14.44 16l6.107-6.12L18.667 8l-8 8 8 8 1.88-1.893z"></path></svg>',
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="18" height="18" fill="currentColor"><path d="M11.453 22.107L17.56 16l-6.107-6.12L13.333 8l8 8-8 8-1.88-1.893z"></path></svg>',
        ],
        responsive: {
            0: {
                items: 1,
                slideBy: 1,
            },
            768: {
                items: 3,
                slideBy: 3,
            },
            992: {
                items: 4,
                slideBy: 4,
            },
        },
    });
})();

// df-begin-customization
// Create carousels
$(document).ready(function() {
    // Find gallery cards
    var galleryCards = document.querySelectorAll('.kg-gallery-card');
    galleryCards.forEach(function (galleryCard) {
        // Find gallery images
        var imageElements = galleryCard.querySelectorAll('img');
        if (imageElements.length > 1) {
            // Find captions
            var captions = [];
            var figCaption = galleryCard.querySelector('figcaption');
            if (figCaption) {
                var strings = figCaption.textContent.split('|');
                strings.forEach(function (string) {
                    var span = document.createElement('span');
                    span.textContent = string;
                    captions.push(span);
                });
            }

            // Create figures
            let figures = [];
            imageElements.forEach(function (image) {
                var figure = document.createElement('figure');
                figure.classList.add('kg-card', 'kg-card-hascaption', 'kg-image-card');
                image.style.marginLeft = 'auto';
                image.style.marginRight = 'auto';
                image.style.maxWidth = '360px';
                figure.appendChild(image);
                var caption = captions.shift();
                if (caption) {
                    var figCaption = document.createElement('figcaption');
                    figCaption.appendChild(caption);
                    figure.classList.add('kg-card-hascaption');
                    figure.appendChild(figCaption);
                }
                figures.push(figure);
            });

            // Create the carousel
            createCarousel(figures, galleryCard);

            // Remove the original gallery card
            galleryCard.parentNode.removeChild(galleryCard);
        }
    });
});

function createCarousel(carouselItems, insertionPoint) {
    // Create the carousel div element
    var carouselElement = document.createElement('div');
    carouselElement.style.position = 'relative';

    // Create and add a div for the owl carousel
    var owlDiv = document.createElement('div');
    carouselElement.appendChild(owlDiv);
    owlDiv.classList.add('owl', 'owl-carousel', 'owl-theme');

    // Clone carousel items and add them to the owl div
    carouselItems.forEach(function (item) {
        var clonedItem = item.cloneNode(true);
        owlDiv.appendChild(clonedItem);
    });

    // Create and add the left navigation button
    var leftButton = createSvgButton('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="32" height="32" fill="currentColor"><path d="M20.547 22.107L14.44 16l6.107-6.12L18.667 8l-8 8 8 8 1.88-1.893z"></path></svg>');
    carouselElement.appendChild(leftButton);
    leftButton.addEventListener('click', function() {
        $(owlDiv).trigger('prev.owl.carousel');
    });

    // Create and add the right navigation button
    var rightButton = createSvgButton('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="32" height="32" fill="currentColor"><path d="M11.453 22.107L17.56 16l-6.107-6.12L13.333 8l8 8-8 8-1.88-1.893z"></path></svg>');
    carouselElement.appendChild(rightButton);
    rightButton.style.right = '0%';
    rightButton.addEventListener('click', function() {
        $(owlDiv).trigger('next.owl.carousel');
    });

    // Insert owl carousel
    insertionPoint.parentNode.insertBefore(carouselElement, insertionPoint);
    
    // Connect owl carousel
    $(owlDiv).owlCarousel({
        items: 1,
        loop: true,
    })

    // Make the navigation dot backgrounds transparent
    var dotButtons = document.querySelectorAll('button.owl-dot');
    dotButtons.forEach(function(button) {
        button.style.backgroundColor = 'transparent';
    });
}

function createSvgButton(svgPathData) {
    // Create button element
    var button = document.createElement('button');
    button.style.alignItems = 'center';
    button.style.backgroundColor = 'rgba(255,255,255,0.5)';
    button.style.borderColor = 'transparent';
    button.style.borderRadius = '50%';
    button.style.cursor = 'pointer';
    button.style.display = 'flex';
    button.style.justifyContent = 'center';
    button.style.padding = '5px';
    button.style.position = 'absolute';
    button.style.top = '50%';
    button.style.transform = 'translateY(-50%)';
    button.style.zIndex = 100;

    // Create SVG element
    var parser = new DOMParser();
    var svgDoc = parser.parseFromString(svgPathData, 'image/svg+xml');
    var svgElement = svgDoc.documentElement;

    // Make SVG gray to start and black when hovering
    svgElement.style.fill = 'gray';
    svgElement.addEventListener('mouseenter', function() {
        svgElement.style.fill = 'black';
    });
    svgElement.addEventListener('mouseleave', function() {
        svgElement.style.fill = 'gray';
    });

    // Append SVG to button
    button.appendChild(svgElement);

    return button;
}
// df-end-customization